module.exports = __webpack_public_path__ + "img/network-err.619bde5a.png";